export function sendSelected (companyList,param) {
    let selected
    let paramArray = param.split('|')
    if(paramArray[1] !== "undefined"){
    companyList.forEach(element => {
        if(element.companyId === paramArray[0] && element.productCode === paramArray[1] && element.productType === paramArray[2])
        {
            selected=element;
        }
    });
    }else{
        companyList.forEach(element => {
            if(element.companyId === paramArray[0])
            {
                selected=element;
            }
        });
    }
    return selected
 }